// extracted by mini-css-extract-plugin
module.exports = {"container":"nF","heading":"oF","legend":"pF","image":"qF","info":"rF","check":"sF","disabled":"tF","item":"uF","description":"vF","boxSelect":"wF"};